export default __webpack_public_path__ + "static/media/the-empress@2x.1e932e96.png";